export const VEHICLE_DOCUMENT_STATUS_LABELS = {
	1: "Ativo",
	2: "Vencido",
	3: "Inválido",
};
export const VEHICLE_DOCUMENT_STATUS_COLORS = {
	1: "bg-utility-indigo-50 text-utility-indigo-700 border-utility-indigo-200",
	2: "bg-utility-error-50 text-utility-error-700 border-utility-error-200",
	3: "bg-utility-error-50 text-utility-error-700 border-utility-error-200",
};
export const VEHICLE_DOCUMENT_DOT_COLORS = {
	1: "bg-utility-indigo-500",
	2: "bg-utility-error-500",
	3: "bg-utility-error-500",
};
